import React from "react";
import { Label } from "ui/components/label";
import { MonthPickerButton } from "components/month-picker-button";
import { Button } from "ui/index";
import {
  ClientCombobox
} from "@/modules/crm/clients/components/directus-combobox";
import UserCombobox from "components/directus/combobox/user";
import { EMPLOYEE_FILTERS } from "components/employee/constants";
import { startOfMonth, endOfMonth } from "date-fns";
import { formatDateForAPI } from "utils/utils";
import { EvtDepartmentMultiselect } from "components/multiselect";
import FilterWrapper from "components/filter/wrapper";

export function MonthFilter({ localFilters, handleSetLocalFilters, jobType }) {
  return (
    <FilterWrapper label="Select Month">
      <MonthPickerButton
        selectedMonth={
          localFilters?.jobs?.billables?.collected_date?._gte
            ? new Date(localFilters.jobs.billables.collected_date._gte)
            : null
        }
        onMonthSelect={(month) => {
          if (month) {
            const monthStart = formatDateForAPI(startOfMonth(month));
            const monthEnd = formatDateForAPI(endOfMonth(month));

            const baseFilters = {
              jobs: {
                type: { _eq: jobType },
                billables: {
                  status: {
                    _eq: "collected",
                  },
                  collected_date: {
                    _gte: monthStart,
                    _lte: monthEnd,
                  },
                },
              },
              deep: {
                jobs: {
                  _filters: {
                    billables: {
                      status: {
                        _eq: "collected",
                      },
                      collected_date: {
                        _gte: monthStart,
                        _lte: monthEnd,
                      },
                    },
                  },
                  billables: {
                    _filters: {
                      status: {
                        _eq: "collected",
                      },
                      collected_date: {
                        _gte: monthStart,
                        _lte: monthEnd,
                      },
                    },
                  },
                },
              },
            };

            handleSetLocalFilters(baseFilters);
          }
        }}
        onClear={() => {
          const baseFilters = {
            deep: {
              jobs: {
                _filters: {
                  billables: {
                    collected_date: undefined,
                  },
                },
                _limit: -1,
                billables: {
                  _filters: {
                    collected_date: undefined,
                  },
                  _limit: -1,
                },
              },
            },
            jobs: {
              ...localFilters?.jobs,
              billables: {
                collected_date: undefined,
              },
            },
          };

          handleSetLocalFilters(baseFilters);
        }}
        placeholder="Select"
        className="w-full"
      />
    </FilterWrapper>
  );
}

export function SalesCoordinatorFilter({
  localFilters,
  handleSetLocalFilters,
  isOpen,
}) {
  return (
    <FilterWrapper label="Sales Coordinator">
      <UserCombobox
        value={localFilters?.sales_coordinator?._eq}
        onChange={(selectedItem) => {
          handleSetLocalFilters({ sales_coordinator: { _eq: selectedItem } });
        }}
        filter={EMPLOYEE_FILTERS.sales_coordinating}
        dependenton={isOpen}
      />
    </FilterWrapper>
  );
}

export function AccountManagerFilter({
  localFilters,
  handleSetLocalFilters,
  isOpen,
}) {
  return (
    <FilterWrapper label="Account Manager">
      <UserCombobox
        value={localFilters?.account_manager?._eq}
        onChange={(selectedItem) => {
          handleSetLocalFilters({ account_manager: { _eq: selectedItem } });
        }}
        filter={EMPLOYEE_FILTERS.account_manager}
        dependenton={isOpen}
      />
    </FilterWrapper>
  );
}

export function ClientFilter({ localFilters, handleSetLocalFilters, isOpen }) {
  return (
    <FilterWrapper label="Client">
      <ClientCombobox
        value={localFilters?.client?._eq}
        onChange={(selectedItem) => {
          handleSetLocalFilters({ client: { _eq: selectedItem } });
        }}
        filter={EMPLOYEE_FILTERS.client}
        dependenton={isOpen}
      />
    </FilterWrapper>
  );
}

export function DepartmentsFilter({ localFilters, handleSetLocalFilters }) {
  return (
    <FilterWrapper label="Departments">
      <EvtDepartmentMultiselect
        values={localFilters?.jobs?.employees?.employee?.department?._in || []}
        onChange={(selectedDepartmentIds) => {
          handleSetLocalFilters({
            jobs: {
              ...localFilters?.jobs,
              employees: {
                employee: {
                  department: {
                    _in:
                      selectedDepartmentIds.length > 0
                        ? selectedDepartmentIds
                        : undefined,
                  },
                },
              },
              status: { _nin: ["cancelled", "archived"] },
            },
          });
        }}
        placeholder="Search & Select"
      />
    </FilterWrapper>
  );
}
